
import Vue from "vue";
import filters from "@/filters";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Action } from "vuex-class";
import { AxiosResponse } from "axios";

import Events1 from "@/components/content-management/events/Events1.vue";
import Events2 from "@/components/content-management/events/Events2.vue";
import Events4 from "@/components/content-management/events/Events4.vue";

@Component({
  components: {
    Events4,
    Events2,
    Events1,
  },
  filters,
})
export default class Events extends Vue {
  @Action("getSchoolEvents", { namespace: "school" })
  private getSchoolEvents: any;

  @Prop({ default: null })
  private params!: any;
  @Prop({ default: 1 })
  private templateNumber!: number;

  private events: Array<any> = [];
  private page = 1;
  private isLastPage = false;
  private isLoading = false;

  private getData(isReload: boolean = false) {
    if (isReload) {
      this.events = [];
      this.page = 1;
      this.isLastPage = false;
    }
    if (!this.isLoading && !this.isLastPage) {
      this.getSchoolEvents({
        params: {
          page: this.page,
          target: this.params?.target,
        },
        success: (response: AxiosResponse) => {
          const isLastPage = response.data.data.last_page === this.page;
          this.events = [...this.events, ...response.data.data.data];
          this.page = isLastPage ? this.page : this.page + 1;
          this.isLastPage = isLastPage;
        },
      });
    }
  }

  private created() {
    this.getData();
  }
}
